import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.reduce";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import muiWithStyles from '@material-ui/styles/withStyles';
import camelCase from 'lodash.camelcase';
import { getRepeatedItems, pick } from './utils';
var baseTheme = createMuiTheme();
export var getStyleAttrs = function getStyleAttrs(stylesCreator) {
  return Object.keys(typeof stylesCreator === 'function' ? stylesCreator(baseTheme) : stylesCreator);
};
export var mergeStyleCreators = function mergeStyleCreators() {
  for (var _len = arguments.length, creators = new Array(_len), _key = 0; _key < _len; _key++) {
    creators[_key] = arguments[_key];
  }

  return function (theme) {
    if (!creators.length) return {};
    if (creators.length === 1) return creators[0](theme);

    if (process.env !== 'production') {
      var list = [];
      creators.forEach(function (c) {
        list = [].concat(_toConsumableArray(list), _toConsumableArray(getStyleAttrs(c)));
      });
      var repeatedList = getRepeatedItems(list);

      if (repeatedList.length) {
        console.warn( // eslint-disable-next-line max-len
        "mui-styling: Styles collision alert! attributes: [".concat(repeatedList.join(', ' // eslint-disable-next-line max-len
        ), "]. This might cause bugs in styling, please check these style attributes"));
      }
    }

    return creators.reduce(function (a, b) {
      return _extends({}, a, {}, typeof b === 'function' ? b(theme) : b);
    }, {});
  };
};
export var attachStylingParams = function attachStylingParams(Component, stylesCreator) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$name = options.name,
      name = _options$name === void 0 ? '' : _options$name;
  var attrs = getStyleAttrs(stylesCreator);

  if (process.env !== 'production') {
    if (!name) {
      console.warn( // eslint-disable-next-line max-len
      "mui-styling: [attachStylingParams] You forget to pass \"name\" in options at \"".concat(Component.displayName, "\""));
    }
  }

  var pickClasses = function pickClasses(classes) {
    return pick(classes, attrs);
  };

  var getOverrides = function getOverrides(css) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var overrides = props[camelCase("".concat(name, "Overrides"))];
    return {
      overrides: pickClasses(overrides || css)
    };
  };

  Component.displayName = name || Component.displayName;
  Component.styleAttrs = attrs;
  Component.pickClasses = pickClasses;
  Component.getOverrides = getOverrides;
};
export var withStyles = function withStyles(styleCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (WrappedComponent) {
    var EnhancedComponent = muiWithStyles(styleCreator, options)(function (props) {
      var classes = props.classes,
          overrides = props.overrides;
      return React.createElement(WrappedComponent, _extends({}, props, {
        css: overrides || classes
      }));
    });
    attachStylingParams(EnhancedComponent, styleCreator, options);
    return EnhancedComponent;
  };
};